interface Props {
  value: string | undefined
  max: number
}

export default function CharCounter({ value, max }: Props) {
  const len = (value ?? '').length
  const nearLimit = len >= max * 0.9
  const atLimit = len >= max
  return (
    <p className={
      atLimit ? 'mt-1 text-xs text-rose-600'
        : nearLimit ? 'mt-1 text-xs text-amber-600'
        : 'mt-1 text-xs text-gray-400'
    }>
      {len}/{max}
    </p>
  )
}
